import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import Button from '@mui/material/Button';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { getPartnerGuid, hasAuthourity } from '../../../../../lib/access.es6';
import HelpDrawerInc from '../../../../../shared-ui/HelpDrawerInc';
import { hashHistory } from 'react-router';
import { getUserEmail, getUserFullname } from '../../../../../lib/access.es6';
import posthog from 'posthog-js';
import { PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS } from '../../../../../routes/PartnersEnum';


const PolicyHeader = (props) => {
	const classes = useStyle();
	const handleRegisterCustomer = () => {

		hashHistory.push('admin/generate-policy');
		posthog.capture('clicked_get_a_policy_homepage', {
			email: `${getUserEmail()}`,
			name: `${getUserFullname()}`,
			partner: `${getPartnerGuid()}`,
			timestamp: new Date().toLocaleString(),
		});
	}
	return (


		<section className={classes.policyheader}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={5} md={5}>
					<div className={classes.policytitle}>
						<h1>Customer Status</h1>
					</div>
				</Grid>

				<Grid item xs={12} sm={7} md={7} >
					<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>


						<div className={classes.registerbtn}>
							{(
								(PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid()) && hasAuthourity('REGISTER_CUSTOMER')) ||
								!PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid())
							) && (
									(getPartnerGuid() === 'banja' || getPartnerGuid() === 'omk' || PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid())
									) ? (
										<Button variant="contained" endIcon={<AddOutlinedIcon />} onClick={handleRegisterCustomer}>
											Generate Policy
										</Button>
									) : (
										<Button variant="contained" endIcon={<AddOutlinedIcon />} onClick={props.open}>
											Register Customer
										</Button>
									)
								)}
						</div>

						<HelpDrawerInc section="customer" marginTop="5px" marginRight="25px" />

					</div>

				</Grid>
			</Grid>
		</section>
	)
}

export default PolicyHeader